<template>
  <div>
    <ul class="nav-box">
      <li class="nav-item" v-for="(item, index) in navList" :key="index">
        <router-link
          class="nav-item-link"
          active-class="routerOn"
          :to="item.path"
        >
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          name: "我的账户",
          path: "/user/account",
        },
        {
          name: "发布资产",
          path: "/user/resource",
        },
        {
          name: "我的资产",
          path: "/user/myAssets",
        },
        {
          name: "已购资产",
          path: "/user/myDownload",
        },
        {
          name: "我的余额",
          path: "/user/integral",
        },
        {
          name: "消息通知",
          path: "/user/notice",
        },
        {
          name: "热门活动",
          path: "/user/active",
        },
        {
          name: "我的工单",
          path: "/user/workorder",
        },
        {
          name: "搜点提现",
          path: "/user/withdrawal",
        },
        {
          name: "红包提现",
          path: "/user/tx",
        }
          ],
        };
      },
};
</script>

<style lang="less" scoped>
.nav-box {
  overflow: hidden;
  background: #ffffff;
  .nav-item {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    text-align: center;
    color: #333333;
    .nav-item-link {
      display: block;
      color: #333333;
      background: #ffffff;
      text-decoration: none;
    }
    .routerOn {
      color: #ffffff;
      //background: #fa5c5c;
      background-color: #1c6f6e;
    }
  }
}
</style>
